<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <material-card
          color="green"
          :loading="loading"
        >
          <v-banner two-line>
            <v-avatar
              slot="icon"
              color="deep-purple accent-4"
              size="40"
            >
              <v-icon
                icon="mdi-lock"
                color="white"
              >
                mdi-door-open
              </v-icon>
            </v-avatar>

            O sistema entrará em contato com o equipamento escolhido enviando todas as biometrias da pessoa selecionada.
            O responsável pelo pedido de acesso deve ser um Professor, TAE ou Terceirizado.

          </v-banner>
          <PersonToolbar :personId=this.$route.params.id></PersonToolbar>

          <v-form
            ref="form"
          >
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    class="purple-input"
                    label="Pessoa"
                    disabled
                    :value="this.person ? this.person.name: ''"
                    @keyup.enter="handleSubmit"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="8"
                >
                  <v-autocomplete
                    v-model="responsible_id"
                    :items="persons.items"
                    :loading="loading"
                    :search-input.sync="search"
                    item-text="name"
                    item-value="id"
                    label="Responsável"
                    placeholder="Procurar"
                    :clearable="true"
                    prepend-icon="mdi-account-card-details"
                    :rules="[(v)=> !!v || 'Responsável não pode ser vazio']"
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-select
                    v-model="equipment_id"
                    label="Local"
                    :items="equipments.items"
                    :loading="loading"
                    item-text="name"
                    item-value="id"
                    single-line
                    :rules="[(v)=> !!v || 'Equipamento não pode ser vazio']"
                    prepend-icon="mdi-door"

                    @keyup.enter="handleSubmit"
                  />

                </v-col>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    class="text-right"
                  >
                    <v-btn
                      class="text-right"
                      :loading="loading"
                      @click="handleSubmit()"
                    >
                      <v-icon left>
                        mdi-door-open
                      </v-icon>
                      CONCEDER ACESSO
                    </v-btn>
                  </v-col>
                </v-row>
              </v-row>
              <v-divider
                class="mx-4"
              ></v-divider>
              <data-grid
                :headers="headers"
                :items="access"
                :loading="loading"
              >
                <template v-slot:item.grant_timestamp="{ item }">
                  {{formatedTimezone(item.grant_timestamp)}}
                </template>
                <template v-slot:item.action="{ item }">

                  <v-btn
                    :title="'Revogar acesso em '+item.equipment.name "
                    text
                    icon
                    color="red"
                    @click="revoke(item)"
                  >
                    <v-icon>mdi-cancel</v-icon>
                  </v-btn>
                </template>
              </data-grid>
            </v-container>
          </v-form>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import {mapState,} from 'vuex'
    import {toBrowserTimezoneAndFormat} from '../../utils/datetime'

    export default {
        data() {
            return {
                person: {},
                responsible_id: 7,
                equipment_id: null,
                search: null,
                access: [],
                headers: [
                    {text: 'A partir de', value: 'grant_timestamp'},
                    {text: 'Local', value: 'equipment.name'},
                    {text: 'Responsável', value: 'responsible.name'},
                    {text: 'Concedido por ', value: 'granter.name'},
                    {text: 'Revogar Acesso ', value: 'action'},
                ],
            }
        },
        computed: {
            ...mapState('person', ['persons']),
            ...mapState('account', ['current_unity']),
            ...mapState('equipment', ['equipments']),
            ...mapState('app', ['loading']),
        },
        mounted() {
            this.get_equipments()
            this.get_access()
            this.get_person()
        },
        methods: {
            handleSubmit() {
                if (this.$refs.form.validate())
                    return this.grant()
            },
            get_equipments() {
                this.$store.dispatch('equipment/LIST', {
                    unity_id: this.current_unity.id,
                    sortBy: ['name'],
                    sortDesc: [false]
                })
            },
            get_access() {
                this.$store.dispatch('person/GET_ACCESS', {
                    id: this.$route.params.id,
                    unity_id: this.current_unity.id
                }).then((response) => this.access = response)
            },
            get_person() {
                this.$store.dispatch('person/GET', {id: this.$route.params.id}).then((response) => {
                    this.person = response
                })
            },
            grant() {
                this.$store.dispatch('equipment/GRANT', {
                    id: this.equipment_id,
                    person_id: this.$route.params.id,
                    responsible_id: this.responsible_id,
                }).then((response) => {
                    this.$store.commit('app/SHOW_NOTIFICATION', {
                        body: `Permissão ao ${response.equipment.name} concedida.`,
                        color: 'green',
                    })
                    this.get_access()
                })
            },
            revoke(access) {
                if (confirm('Essa ação não pode ser desfeita.'))
                    this.$store.dispatch('equipment/REVOKE', access).then((response) => {
                        this.get_access()
                    })

            },
            formatedTimezone(timestamp) {
                return toBrowserTimezoneAndFormat(timestamp)
            }
        },
        watch: {
            search() {
                this.$store.dispatch('person/LIST', {
                    options: {q: this.search, sortBy: ['name'], sortDesc: [false]},
                    extra: {person_type: [2, 3, 4]}
                })
            },
            current_unity() {
                this.get_equipments()
            }
        }
    }
</script>
